var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTick = function SvgTick(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 235,
    viewBox: "0 0 234 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.222 108.6V117.544C214.21 138.51 207.421 158.909 194.868 175.701C182.315 192.493 164.67 204.777 144.566 210.721C124.461 216.666 102.973 215.952 83.3069 208.686C63.6409 201.421 46.8504 187.993 35.4395 170.405C24.0285 152.817 18.6086 132.012 19.9881 111.092C21.3675 90.1722 29.4724 70.2588 43.094 54.3216C56.7155 38.3844 75.1239 27.2774 95.5736 22.657C116.023 18.0366 137.419 20.1505 156.569 28.6834",
    stroke: "#04a04a",
    strokeWidth: 14.5833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.221 39.7677L116.999 137.087L87.832 107.92",
    stroke: "#04a04a",
    strokeWidth: 14.5833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick.59a55eb925aa6214acc3ff4cbcee82ec.svg";